import { type ReactNode } from 'react';
import ReactModal from 'react-bootstrap/Modal';

const VARIANT_DEFAULT = 'default';
const VARIANT_SINGLE_SECTION = 'single-section';

const getVariantClassName = (variant: string) => (variant === VARIANT_SINGLE_SECTION ? 'modal__single-section' : null);

interface ModalProps {
  backdrop?: boolean | 'static';
  centered?: boolean;
  children: ReactNode;
  footer?: ReactNode;
  heading?: string;
  onHide: () => void;
  scrollable?: boolean;
  show: boolean;
  variant?: typeof VARIANT_DEFAULT | typeof VARIANT_SINGLE_SECTION;
}

const Modal = ({
  backdrop = true,
  centered = false,
  children,
  footer = null,
  heading = '',
  onHide,
  scrollable = true,
  show,
  variant = VARIANT_DEFAULT,
}: ModalProps) => (
  <ReactModal
    backdrop={backdrop}
    centered={centered}
    className={getVariantClassName(variant) as string | undefined}
    onHide={onHide}
    scrollable={scrollable}
    show={show}
  >
    <ReactModal.Header closeButton>{heading && <ReactModal.Title>{heading}</ReactModal.Title>}</ReactModal.Header>
    <ReactModal.Body>{children}</ReactModal.Body>
    {footer && <ReactModal.Footer>{footer}</ReactModal.Footer>}
  </ReactModal>
);

export default Modal;
